<template>
    <div class="contact-subscriptions">
        <template v-if="!hasSubscriptions">
            <div class="contact-view__no-data">Contact has no subscriptions</div>
        </template>

        <template v-else>
            <div class="contact-subscriptions__header">
                <label class="contact-subscriptions__title">Type</label>
                <label class="contact-subscriptions__title">Status</label>
                <label class="contact-subscriptions__title">Reason</label>
                <label class="contact-subscriptions__title">Updated</label>
            </div>

            <contact-subscription
                v-for="subscription in subscriptions"
                :key="subscription.id"
                :subscription="subscription"
                data-test="contact-subscriptions"
            />
        </template>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import ContactSubscription from './ContactSubscription.vue';

const props = defineProps({
    subscriptions: {
        type: Array,
        required: true,
    },
});

const hasSubscriptions = computed(() => props.subscriptions.length > 0);
</script>

<style lang="scss">
.contact-subscriptions {
    display: flex;
    flex-direction: column;
}

.contact-subscriptions__header {
    display: grid;
    grid-template-columns: 20% 20% 30% 30%;
    font-family: var(--font-open-sans);
    font-weight: var(--weight-regular);
    font-size: 0.8125rem;
    line-height: 1.25rem;
    color: var(--color-grey-600);
    margin-bottom: 8px;
}

.contact-subscriptions__title {
    margin: 0;
    padding: 0 16px;
}
</style>
